import { Headset, UserRound } from "lucide-react";
import { SupportStatus, supportDate } from "@/components/SupportStatus";
import { SupportAttachment } from "@/components/SupportAttachment";

export const SupportMessage = ({ message, admin, currentEmail, customerName, company, ticketId }) => {
  const fromSupport = message.kind !== "client";
  const author = fromSupport
    ? admin && message.sender_email === currentEmail ? "Tu · Assistenza" : "Assistenza Cosmely"
    : admin ? `${customerName} · ${company}` : "Tu";
  const ownMessage = admin ? fromSupport : !fromSupport;

  return (
    <article className={`flex ${ownMessage ? "justify-end" : "justify-start"}`}
             data-testid={`support-message-${message.id}`}>
      <div className={`w-fit max-w-[92%] sm:max-w-[82%] px-4 py-4 sm:px-5 rounded-sm border min-w-0 ${fromSupport
        ? "bg-[#1E2622] border-[#516752] text-white"
        : "bg-[#F7F4EE] border-[#E2D7C5] text-[#1A1A1A]"}`}
           data-testid={`support-message-sender-type-${message.id}`}
           data-sender={fromSupport ? "support" : "customer"}>
        <div className="flex items-start gap-2 sm:gap-3 min-w-0">
          <span aria-hidden="true" className={`p-1.5 shrink-0 rounded-sm ${fromSupport ? "bg-[#B6CFAD] text-[#1E2622]" : "bg-[#E2D7C5] text-[#665543]"}`}>
            {fromSupport ? <Headset className="w-4 h-4" /> : <UserRound className="w-4 h-4" />}
          </span>
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
              <strong className="text-sm break-all" data-testid={`support-message-author-${message.id}`}>{author}</strong>
              <time className={`text-xs ${fromSupport ? "text-[#CAD6CA]" : "text-[#70675C]"}`}
                    data-testid={`support-message-date-${message.id}`}>{supportDate(message.created_at)}</time>
            </div>
            {message.status_to && <div className="flex flex-wrap items-center gap-2 mt-2 text-xs"
                  data-testid={`support-message-status-${message.id}`}>
              <span>Stato aggiornato:</span>
              <SupportStatus status={message.status_to} testId={`support-message-status-badge-${message.id}`} />
            </div>}
            {message.body && <p className="whitespace-pre-wrap break-words [overflow-wrap:anywhere] text-sm mt-3 leading-relaxed"
                                data-testid={`support-message-body-${message.id}`}>{message.body}</p>}
            {message.attachments?.length > 0 && <div className="mt-4 pt-3 border-t border-current/20 space-y-2"
                   data-testid={`support-message-attachments-${message.id}`}>
              {message.attachments.map(attachment => (
                <SupportAttachment key={attachment.id} ticketId={ticketId} attachment={attachment}
                                   dark={fromSupport} admin={admin} />
              ))}
            </div>}
          </div>
        </div>
      </div>
    </article>
  );
};